// extracted by mini-css-extract-plugin
export default {"header":"BimWorkOrderPriceMtrDistEditConfirmationDialog_header__oknKK","footer":"BimWorkOrderPriceMtrDistEditConfirmationDialog_footer__CiSE-"};